<template>
  <qtm-dialog-card v-model="open" closable color="white" height="80vh" width="900">
    <template v-slot:activator="{ props: activator }">
      <div
        v-bind="activator"
        class="d-flex align-center justify-space-between bg-background cursor-pointer mt-2 pr-2"
        @click="unreadMsg = false"
      >
        <qtm-btn prepend-icon="mdi-message-outline" tertiary>
          Message Your Supplier
        </qtm-btn>
        <v-icon v-if="unreadMsg" color="primary" icon="mdi-email" />
      </div>
    </template>
      <supplier-chat :order="order" :quote="quote" type="order" />
  </qtm-dialog-card>
</template>

<script setup lang="ts">
import type { Order, Quote } from '@quotetome/materials-api'
import SupplierChat from '@/components/vendors/supplier-chat.vue'

export interface Props {
  order: Order
  quote: Quote
}

const props = defineProps<Props>()

const open = ref(false)
const unreadMsg = ref(false)

const authStore = useAuthStore()
const user = authStore.user!

const { $api, $error } = useNuxtApp()

onMounted(async () => {
  if (user.id === props.order.owner!.id) {
    try {
      unreadMsg.value = await $api.v1.quotes.chat.list(props.quote.id!, { limit: 1, unread: true })
        .then(response => response.count > 0)
    }
    catch (error) {
      $error.report(error)
    }
  }
})
</script>
